import { Directive, Input, TemplateRef } from '@angular/core';
import { TableColumn } from './table-column';

/**
 * provides a way to reference templates
 *
 * Example:
 *
 * ```html
 * <ng-template cellTemplateName="createdOn" let-row="row">
 *     {{row.createdOn | date:'MM/dd/yyyy'}}
 * </ng-template>
 * ```
 */
@Directive({
  selector: 'ng-template[cellTemplateName]'
})
export class CellTemplateRefDirective {

  constructor(public templateRef: TemplateRef<CellTemplateContext<any>>) { };

  /** this should correspond to a name for a column. */
  @Input() cellTemplateName: string | undefined;
}

export interface CellTemplateContext<TRow> {

  $implicit: any;
  /** the source column information */
  col: TableColumn<TRow>;

  /** the row contenxt */
  row?: TRow;
}
